export enum HardwareMonitoringId {
  FilterCleaner = "FilterCleaner",
  BrushesFront = "BrushesFront",
  BrushRoller = "BrushRoller",
  DropSensor = "DropSensor",
  Filter = "Filter",
  Wheels = "Wheels",
  SweepingLip = "SweepingLip",
  DriveMotorLeft = "DriveMotorLeft",
  DriveMotorRight = "DriveMotorRight",
  FanOne = "FanOne",
  FanTwo = "FanTwo",
  BrushesFrontMotors = "BrushesFrontMotors",
  BrushRollerMotor = "BrushRollerMotor",
}

export enum ReplacePermissionLevel {
  ServiceOnly = "ServiceOnly",
  All = "All",
}

export enum HardwareMonitoringSaveType {
  Lifetime = "Lifetime",
  MotorSubcompLifetime = "MotorSubcompLifetime",
  MaintenanceInterval = "MaintenanceInterval",
  Counters = "Counters",
}

